export default "__VITE_ASSET__CP_Ccn0r__"